import styled from 'styled-components'

const LogoWrapper = styled.div`
  .ribbon-front {
    // fill: #4498d6;
    fill: var(--dark-color);
    stroke: var(--primary-color-light);
  }

  .ribbon-level-1 {
    // fill: #005ba1;
    fill: var(--primary-color-light);
  }

  .ribbon-level-2 {
    // fill: #008fc7;
    fill: var(--dark-color);
    stroke: var(--primary-color-light);
  }

  .ribbon-level-3 {
    // fill: #005ba1;
    fill: var(--primary-color-light);
  }

  .ribbon-level-4 {
    // fill: #059bd6;
    fill: var(--dark-color);
    stroke: var(--primary-color-light);
  }

  .title {
    // fill: #cc272d;
    fill: var(--primary-color);
  }

  .mixer-body {
    fill: #dd544c;
  }

  .mixer-grinder-holder {
    fill: #0e3263;
  }

  .mixer-panel {
    fill: #96332d;
  }

  .container-top {
    fill: #0e3364;
  }

  .container-body {
    fill: #b3ccd1;
  }
`

export const Logo = ({ ...props }) => (
  <LogoWrapper>
    <svg
      width="664"
      height="246"
      viewBox="0 0 664 246"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M97.5 111C88.3 99.4 71.1667 92.3333 64 90.5C80 78 85.5 71.5 86.5 67C87.5 62.5 80.5 37.5 77 27C97.5 21.5 122.5 47.5 122.5 47.5C139 62.5 136.167 66.1666 134 68.5L97.5 111Z"
        className="ribbon-level-4"
      />
      <path
        d="M104 75.5L104.5 91.5H135V67C129.8 69.8 120 70.1667 116.5 69.5C104.9 68.3 103.333 73 104 75.5Z"
        className="ribbon-level-3"
      />
      <path
        d="M171.5 96.5L166.5 123H103.5L103.995 72.9652C103.966 72.6709 104 72.5 104 72.5L103.995 72.9652C104.126 74.2631 105.496 77.9621 116.5 80C127 81.4318 136.167 81.1667 144 81.5C175.2 78.7 175.333 90.3333 171.5 96.5Z"
        className="ribbon-level-2"
      />
      <path
        d="M1.49999 109.5L5 158.5L166.5 169.5V151C164 135.5 169 109.5 172 96C156 103 122 99.6111 107.5 98L107.233 97.9703C96.651 96.7943 76.0075 94.5 41.5 94.5C6.69999 94.5 0.333327 104.5 1.49999 109.5Z"
        className="ribbon-level-1"
      />
      <path
        d="M568.168 110.76C577.369 99.1605 594.503 92.0942 601.67 90.2609C585.669 77.7615 580.169 71.2618 579.169 66.762C578.169 62.2622 585.169 37.2634 588.669 26.7639C568.168 21.2642 543.167 47.263 543.167 47.263C526.666 62.2623 529.5 65.9287 531.667 68.262L568.168 110.76Z"
        className="ribbon-level-4"
      />
      <path
        d="M560.87 75.5L560.37 91.5H529.87V67C535.07 69.8 544.87 70.1667 548.37 69.5C559.97 68.3 561.537 73 560.87 75.5Z"
        className="ribbon-level-3"
      />
      <path
        d="M492.71 96L497.71 122.5H560.71L560.215 72.4652C560.244 72.1709 560.21 72 560.21 72L560.215 72.4652C560.084 73.7631 558.714 77.4621 547.71 79.5C537.21 80.9318 528.043 80.6667 520.21 81C489.009 78.2 488.876 89.8333 492.71 96Z"
        className="ribbon-level-2"
      />
      <path
        d="M663.503 110L660.003 159L498.5 170V151.5C501 136 496 110 493 96.5C509 103.5 543.001 100.111 557.501 98.5L557.768 98.4703C568.35 97.2943 588.994 95 623.502 95C658.303 95 664.67 105 663.503 110Z"
        className="ribbon-level-1"
      />
      <path
        d="M122.5 92C118.667 92 110.7 96 109.5 112M122.5 92C119.833 93.7143 114.4 100.114 114 112M122.5 92C121.167 94.6667 119.1 102.4 119.5 112M122.5 92C122.5 92 126 103.429 125 112M122.5 92C122.5 92 130.5 97.7143 130 112M122.5 92C122.5 92 134.5 93.1429 134.5 112"
        className="container-top"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M124.25 78.5C124.25 77.5335 123.466 76.75 122.5 76.75C121.534 76.75 120.75 77.5335 120.75 78.5H124.25ZM120.75 78.5V93H124.25V78.5H120.75Z"
        className="container-top"
      />
      <path
        className="container-body"
        d="M82 110H121C121.552 110 122 110.448 122 111V148.985C122 149.543 121.543 149.993 120.985 149.985L88.0132 149.5C83.2658 149.5 81 147.5 81 140V111C81 110.448 81.4477 110 82 110Z"
      />
      <path
        d="M82 118H126C126.552 118 127 117.552 127 117V111C127 110.448 126.552 110 126 110H82C81.4477 110 81 110.448 81 111V117C81 117.552 81.4477 118 82 118Z"
        className="container-top"
      />
      <path
        d="M161 110H122C121.448 110 121 110.448 121 111V148.985C121 149.543 121.457 149.993 122.015 149.985L154.987 149.5C159.734 149.5 162 147.5 162 140V111C162 110.448 161.552 110 161 110Z"
        className="container-body"
      />
      <path
        d="M161 118H118C117.448 118 117 117.552 117 117V111C117 110.448 117.448 110 118 110H161C161.552 110 162 110.448 162 111V117C162 117.552 161.552 118 161 118Z"
        className="container-top"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.92 71.0077C104.021 71.0028 103.163 70.6042 102.65 69.8663C98.0125 63.1956 93.7215 48.7566 107.986 35.4184C108.617 34.8287 108.994 34.0067 109.029 33.1441C109.332 25.6729 112.137 12.2658 121.596 8.64717C121.861 8.54578 122.142 8.49453 122.425 8.47318C125.482 8.24245 130.866 7.05546 132.884 3.88266C133.397 3.0769 134.026 2.28704 134.931 1.98505C140.235 0.216927 143.622 0.733217 147.731 2.21491C148.235 2.397 148.671 2.72439 149.025 3.12779C150.566 4.88357 153.539 7.5 158.5 7.5L184.16 7.99346C184.386 7.99781 184.611 8.02721 184.829 8.08366C194.486 10.5749 203.624 16.3222 207.725 23.97C207.912 24.3175 208.148 24.6295 208.392 24.9392C209.922 26.879 215.361 36.0075 214.5 67V149.5C214.5 151.157 215.844 152.483 217.501 152.522C223.833 152.669 226.5 153.834 226.5 163V168.5C226.5 170.157 225.157 171.5 223.5 171.5H112C110.343 171.5 109 170.157 109 168.5V163C108.667 159.5 110.2 152.5 119 152.5H180.182C181.027 152.5 181.827 152.154 182.358 151.496C192.181 139.323 205.686 100.088 192.105 80.8213C191.724 80.2805 191.5 79.6413 191.5 78.9796C191.5 78.3629 191.798 77.7904 192.258 77.3798C193.095 76.6325 193.833 75.7492 194.4 74.7389C195.291 73.1529 193.879 71.4912 192.06 71.4813L104.92 71.0077ZM125 34.5L189.978 34.9778C191.643 34.99 193 33.6433 193 31.9779V28.265C193 27.763 192.877 27.2664 192.624 26.8328C189.664 21.7561 185.67 18.9588 178 18H133.5C130.667 18 125 19.9 125 27.5V34.5Z"
        className="mixer-body"
      />
      <path
        d="M195.5 71.5C195.1 74.3 193.5 76.5 191.5 78L111 78.5C105 78.1 103.5 73.1666 103.5 71L195.5 71.5Z"
        className="mixer-grinder-holder"
      />
      <rect
        x="174"
        y="46"
        width="23"
        height="16.8077"
        rx="2"
        className="mixer-panel"
      />
      <path
        className="title"
        d="M260.397 118.413C261.221 115.872 262.079 112.851 262.972 109.349C263.933 105.778 264.929 101.59 265.959 96.783L272.86 64.956H287.383L280.585 97.092C278.937 104.989 277.392 111.306 275.95 116.044C274.508 120.782 272.929 124.73 271.212 127.889C268.465 133.108 264.998 136.884 260.809 139.219C256.62 141.554 251.299 142.721 244.844 142.721C237.977 142.721 232.93 141.416 229.703 138.807C226.544 136.198 224.965 132.043 224.965 126.344C224.965 123.872 225.205 120.954 225.686 117.589C226.235 114.224 227.094 110.104 228.261 105.229C228.879 102.551 229.806 98.7743 231.042 93.899C232.278 89.0237 233.068 85.8307 233.411 84.32L236.81 70.724C231.042 72.2347 226.544 75.0843 223.317 79.273C220.158 83.393 218.579 88.44 218.579 94.414C218.579 95.7873 218.648 96.989 218.785 98.019C218.991 98.9803 219.3 99.873 219.712 100.697C219.849 100.972 219.918 101.178 219.918 101.315C219.987 101.384 220.021 101.452 220.021 101.521C216.313 101.521 213.532 100.731 211.678 99.152C209.893 97.5727 209 95.2037 209 92.045C209 88.2683 210.236 84.5947 212.708 81.024C215.18 77.3847 218.648 74.226 223.111 71.548C226.75 69.3507 230.699 67.6683 234.956 66.501C239.282 65.3337 243.608 64.75 247.934 64.75C248.827 64.75 249.582 64.7843 250.2 64.853C250.887 64.9217 251.779 65.059 252.878 65.265C251.711 69.5223 250.234 74.844 248.449 81.23C246.732 87.616 245.599 91.9077 245.05 94.105C242.647 103.032 241.033 109.521 240.209 113.572C239.385 117.555 238.973 120.816 238.973 123.357C238.973 126.516 239.557 128.85 240.724 130.361C241.891 131.872 243.677 132.627 246.08 132.627C250.131 132.627 253.084 131.597 254.938 129.537C256.861 127.408 258.68 123.7 260.397 118.413ZM333.199 130.979C333.199 129.743 333.337 128.198 333.611 126.344C333.955 124.49 334.607 121.537 335.568 117.486C336.53 113.572 337.148 110.757 337.422 109.04C337.697 107.323 337.834 105.881 337.834 104.714C337.834 102.997 337.525 101.693 336.907 100.8C336.289 99.9073 335.362 99.461 334.126 99.461C332.478 99.461 330.933 100.319 329.491 102.036C328.118 103.684 326.985 105.984 326.092 108.937L319.088 142H304.256L311.775 106.465C311.913 106.053 311.981 105.641 311.981 105.229C312.05 104.817 312.084 104.371 312.084 103.89C312.084 102.517 311.81 101.418 311.26 100.594C310.711 99.77 309.956 99.358 308.994 99.358C307.209 99.358 305.595 100.216 304.153 101.933C302.711 103.581 301.544 105.916 300.651 108.937L293.647 142H278.815L289.733 90.5H304.565L303.432 95.856C305.149 93.8647 307.037 92.3883 309.097 91.427C311.157 90.4657 313.458 89.985 315.998 89.985C319.02 89.985 321.389 90.7403 323.105 92.251C324.891 93.693 326.058 95.8903 326.607 98.843C328.53 95.8903 330.659 93.693 332.993 92.251C335.328 90.809 337.972 90.088 340.924 90.088C344.564 90.088 347.379 91.0837 349.37 93.075C351.362 95.0663 352.357 97.9503 352.357 101.727C352.357 103.306 352.151 105.195 351.739 107.392C351.396 109.521 350.675 112.817 349.576 117.28C348.684 120.782 348.1 123.254 347.825 124.696C347.551 126.138 347.413 127.34 347.413 128.301C347.413 129.743 347.757 130.842 348.443 131.597C349.13 132.284 350.16 132.627 351.533 132.627C353.25 132.627 354.726 132.043 355.962 130.876C357.198 129.709 358.606 127.271 360.185 123.563H364.511C362.314 129.949 359.636 134.721 356.477 137.88C353.387 141.039 349.679 142.618 345.353 142.618C341.508 142.618 338.521 141.588 336.392 139.528C334.264 137.399 333.199 134.55 333.199 130.979ZM385.622 76.801C385.622 79.067 384.798 80.9897 383.15 82.569C381.57 84.1483 379.648 84.938 377.382 84.938C375.116 84.938 373.193 84.1483 371.614 82.569C370.034 80.9897 369.245 79.067 369.245 76.801C369.245 74.535 370.034 72.6123 371.614 71.033C373.193 69.385 375.116 68.561 377.382 68.561C379.648 68.561 381.57 69.385 383.15 71.033C384.798 72.6123 385.622 74.535 385.622 76.801ZM359.357 130.258C359.357 129.365 359.425 128.37 359.563 127.271C359.7 126.104 359.906 124.868 360.181 123.563L367.185 90.5H382.017L374.601 125.52C374.463 126.138 374.36 126.722 374.292 127.271C374.223 127.752 374.189 128.267 374.189 128.816C374.189 130.189 374.498 131.185 375.116 131.803C375.802 132.352 376.901 132.627 378.412 132.627C380.334 132.627 382.154 131.803 383.871 130.155C385.587 128.438 386.858 126.241 387.682 123.563H392.008C389.81 129.812 386.858 134.55 383.15 137.777C379.442 141.004 375.184 142.618 370.378 142.618C366.944 142.618 364.232 141.554 362.241 139.425C360.318 137.228 359.357 134.172 359.357 130.258ZM404.842 132.627C406.558 132.627 408.103 131.906 409.477 130.464C410.85 129.022 411.983 126.928 412.876 124.181L420.086 90.5H434.918L424.721 138.292C428.154 137.056 430.832 135.339 432.755 133.142C434.746 130.876 436.394 127.683 437.699 123.563H442.025C440.445 128.782 438.179 132.97 435.227 136.129C432.343 139.288 428.532 141.519 423.794 142.824L422.249 150.24C421.013 156.008 418.85 160.368 415.76 163.321C412.67 166.274 408.653 167.75 403.709 167.75C400.207 167.75 397.391 166.857 395.263 165.072C393.203 163.287 392.173 160.849 392.173 157.759C392.173 154.394 393.546 151.407 396.293 148.798C399.108 146.257 403.331 144.129 408.962 142.412L410.198 136.85C408.481 138.773 406.593 140.215 404.533 141.176C402.541 142.137 400.31 142.618 397.838 142.618C394.404 142.618 391.692 141.554 389.701 139.425C387.778 137.228 386.817 134.172 386.817 130.258C386.817 129.365 386.885 128.37 387.023 127.271C387.16 126.104 387.366 124.868 387.641 123.563L394.645 90.5H409.477L402.061 125.52C401.992 125.932 401.923 126.378 401.855 126.859C401.786 127.271 401.752 127.683 401.752 128.095C401.752 129.537 401.992 130.67 402.473 131.494C403.022 132.249 403.812 132.627 404.842 132.627ZM407.932 147.562C404.498 148.867 401.958 150.206 400.31 151.579C398.662 153.021 397.838 154.6 397.838 156.317C397.838 157.21 398.181 157.999 398.868 158.686C399.554 159.373 400.378 159.716 401.34 159.716C402.507 159.716 403.64 158.892 404.739 157.244C405.837 155.596 406.696 153.364 407.314 150.549L407.932 147.562ZM471.207 95.238V95.959L472.34 90.5H487.172L479.756 125.52C479.619 126.138 479.516 126.722 479.447 127.271C479.379 127.752 479.344 128.267 479.344 128.816C479.344 130.327 479.688 131.46 480.374 132.215C481.061 132.902 482.125 133.245 483.567 133.245C485.353 133.245 486.966 132.421 488.408 130.773C489.85 129.056 491.018 126.653 491.91 123.563H496.236C494.039 129.88 491.189 134.653 487.687 137.88C484.185 141.039 480.134 142.618 475.533 142.618C472.581 142.618 470.212 141.794 468.426 140.146C466.71 138.498 465.714 136.163 465.439 133.142C463.311 136.301 460.942 138.67 458.332 140.249C455.792 141.828 453.045 142.618 450.092 142.618C445.835 142.618 442.47 141.176 439.998 138.292C437.595 135.408 436.393 131.322 436.393 126.035C436.393 122.19 436.977 118.173 438.144 113.984C439.312 109.795 440.925 105.984 442.985 102.551C445.526 98.4997 448.479 95.4097 451.843 93.281C455.208 91.0837 458.882 89.985 462.864 89.985C465.542 89.985 467.602 90.4657 469.044 91.427C470.486 92.3197 471.207 93.59 471.207 95.238ZM470.28 100.285C470.28 99.255 469.903 98.3623 469.147 97.607C468.392 96.783 467.362 96.371 466.057 96.371C462.281 96.371 458.916 99.5297 455.963 105.847C453.079 112.164 451.637 118.413 451.637 124.593C451.637 127.271 452.015 129.297 452.77 130.67C453.526 131.975 454.865 132.627 456.787 132.627C458.573 132.627 460.289 131.769 461.937 130.052C463.654 128.335 464.787 126.172 465.336 123.563L470.28 100.285Z"
      />
      <path
        className="ribbon-front"
        d="M77.5 144C51.1666 137.667 10 125 0.499969 108C2.16663 123.667 4.49995 159.3 0.499969 176.5C8.5 194.5 34.5 213 93.5 224.5C114.167 229.5 171.1 240.1 233.5 242.5C233.5 242.5 389 252.5 484.5 238.5C484.5 238.5 656.5 219.5 664 179.5V109C646 138.5 560.5 151.5 461 162.5C381.4 171.3 276.167 166.833 233.5 164C121.5 158 77.5 144 77.5 144Z"
      />
      <path
        d="M85.0348 167.176L92.2967 168.927C94.7756 169.525 96.4431 170.544 97.2992 171.985C98.1623 173.397 98.3055 175.298 97.7288 177.69L97.4334 178.914C97.0536 180.489 96.4817 181.709 95.7176 182.574C94.9827 183.446 94.0375 183.974 92.8821 184.159L92.861 184.246C95.0556 185.639 95.7379 188.057 94.908 191.498L94.275 194.123C93.7054 196.485 92.6423 198.142 91.0858 199.094C89.5655 200.023 87.6097 200.2 85.2182 199.623L77.6502 197.798L85.0348 167.176ZM88.7214 181.257C89.6838 181.489 90.4581 181.414 91.0442 181.031C91.6596 180.654 92.1079 179.883 92.3892 178.716L92.8007 177.01C93.0679 175.902 93.0572 175.051 92.7685 174.457C92.5089 173.869 91.9562 173.474 91.1105 173.27L88.7919 172.711L86.8403 180.804L88.7214 181.257ZM86.2732 195.248C87.1189 195.452 87.7987 195.385 88.3125 195.046C88.8333 194.678 89.2274 193.939 89.4946 192.831L90.1381 190.163C90.4757 188.763 90.4599 187.741 90.0907 187.096C89.7577 186.429 89.0371 185.963 87.9289 185.695L85.7853 185.178L83.5172 194.584L86.2732 195.248Z"
        fill="white"
      />
      <path
        d="M107.04 172.174L113.625 173.438L112.726 205.34L107.865 204.407L108.16 198.095L108.143 198.183L102.619 197.123L100.573 203.008L96.0654 202.143L107.04 172.174ZM108.374 193.875L109.143 178.168L109.055 178.151L103.999 193.035L108.374 193.875Z"
        fill="white"
      />
      <path
        d="M121.179 174.835L126.065 175.63L123.932 188.733L132.283 176.642L137.169 177.438L129.492 187.905L132.196 208.543L127.088 207.711L125.214 193.181L122.616 196.816L121.003 206.721L116.118 205.926L121.179 174.835Z"
        fill="white"
      />
      <path
        d="M139.316 177.745L152.682 179.642L152.049 184.098L143.584 182.896L142.414 191.139L149.142 192.093L148.509 196.549L141.782 195.594L140.422 205.173L148.887 206.374L148.255 210.83L134.889 208.933L139.316 177.745Z"
        fill="white"
      />
      <path
        d="M155.138 179.983L162.417 180.89C164.947 181.205 166.719 182.031 167.731 183.367C168.747 184.672 169.103 186.546 168.799 188.987L168.56 190.907C168.155 194.152 166.827 196.072 164.576 196.668L164.565 196.758C165.711 197.263 166.454 198.097 166.793 199.258C167.162 200.422 167.231 201.927 167.001 203.773L166.316 209.265C166.205 210.159 166.144 210.892 166.133 211.465C166.125 212.008 166.208 212.562 166.379 213.128L161.378 212.504C161.262 211.976 161.202 211.485 161.199 211.031C161.195 210.577 161.265 209.769 161.41 208.608L162.122 202.893C162.301 201.464 162.187 200.437 161.781 199.812C161.405 199.19 160.651 198.809 159.52 198.668L157.823 198.457L156.153 211.853L151.241 211.241L155.138 179.983ZM160.166 194.214C161.148 194.336 161.909 194.174 162.449 193.728C163.018 193.285 163.377 192.468 163.525 191.277L163.826 188.866C163.967 187.734 163.86 186.89 163.507 186.332C163.183 185.777 162.589 185.446 161.726 185.339L159.493 185.06L158.38 193.991L160.166 194.214Z"
        fill="white"
      />
      <path
        d="M177.315 200.865L173.312 182.236L178.546 182.803L180.657 194.664L180.746 194.673L185.346 183.539L190.133 184.057L182.236 201.398L180.793 214.73L175.872 214.197L177.315 200.865Z"
        fill="white"
      />
      <path
        d="M203.789 185.39L210.83 185.972L212.112 208.7L212.202 208.707L217.199 186.498L224.24 187.08L221.645 218.473L216.981 218.088L218.945 194.319L218.856 194.311L213.303 217.784L209.177 217.443L207.554 193.377L207.464 193.37L205.5 217.139L201.194 216.783L203.789 185.39Z"
        fill="white"
      />
      <path
        d="M232.653 187.665L239.343 188.113L242.359 219.885L237.42 219.554L236.94 213.253L236.934 213.343L231.321 212.968L230.012 219.059L225.432 218.752L232.653 187.665ZM236.636 209.039L235.475 193.356L235.385 193.35L232.191 208.741L236.636 209.039Z"
        fill="white"
      />
      <path
        d="M251.814 220.866C249.447 220.737 247.672 219.965 246.487 218.548C245.332 217.133 244.822 215.197 244.956 212.741L245.877 195.846C246.011 193.39 246.729 191.521 248.031 190.24C249.362 188.961 251.212 188.385 253.578 188.515C255.944 188.644 257.705 189.416 258.86 190.831C260.044 192.247 260.57 194.184 260.436 196.64L260.254 199.965L255.581 199.71L255.78 196.071C255.886 194.124 255.115 193.105 253.468 193.015C251.82 192.925 250.943 193.854 250.837 195.801L249.879 213.37C249.774 215.287 250.546 216.291 252.193 216.38C253.841 216.47 254.717 215.557 254.822 213.64L255.084 208.832L259.757 209.087L259.514 213.535C259.38 215.991 258.647 217.859 257.316 219.139C256.014 220.42 254.18 220.996 251.814 220.866Z"
        fill="white"
      />
      <path
        d="M264.543 189.551L269.488 189.759L268.95 202.572L274.255 202.795L274.793 189.982L279.739 190.189L278.417 221.662L273.471 221.454L274.066 207.291L268.761 207.068L268.166 221.231L263.22 221.023L264.543 189.551Z"
        fill="white"
      />
      <path
        d="M283.624 190.274L288.572 190.437L287.535 221.92L282.587 221.757L283.624 190.274Z"
        fill="white"
      />
      <path
        d="M293.04 190.633L299.248 190.774L303.633 209.734L303.723 209.736L304.152 190.886L308.561 190.986L307.843 222.478L302.76 222.362L297.345 199.238L297.255 199.236L296.731 222.225L292.322 222.125L293.04 190.633Z"
        fill="white"
      />
      <path
        d="M312.767 191.054L326.266 191.196L326.219 195.696L317.669 195.606L317.582 203.93L324.377 204.002L324.329 208.502L317.535 208.43L317.433 218.105L325.982 218.195L325.935 222.694L312.436 222.552L312.767 191.054Z"
        fill="white"
      />
      <path
        d="M328.368 191.217L335.703 191.208C338.253 191.206 340.113 191.804 341.285 193.002C342.456 194.171 343.043 195.985 343.046 198.445L343.048 200.38C343.051 203.65 341.974 205.722 339.815 206.594L339.815 206.684C341.015 207.043 341.856 207.777 342.337 208.886C342.848 209.996 343.105 211.48 343.107 213.34L343.113 218.875C343.114 219.775 343.145 220.51 343.206 221.08C343.266 221.62 343.417 222.16 343.658 222.7L338.618 222.705C338.437 222.195 338.316 221.716 338.256 221.266C338.195 220.816 338.165 220.006 338.163 218.836L338.157 213.076C338.155 211.636 337.914 210.631 337.434 210.062C336.983 209.492 336.188 209.208 335.048 209.209L333.338 209.211L333.353 222.711L328.403 222.717L328.368 191.217ZM335.133 204.709C336.123 204.708 336.857 204.452 337.337 203.942C337.846 203.431 338.1 202.576 338.099 201.376L338.096 198.946C338.095 197.806 337.884 196.981 337.463 196.472C337.073 195.962 336.443 195.708 335.573 195.709L333.323 195.711L333.333 204.711L335.133 204.709Z"
        fill="white"
      />
      <path
        d="M346.674 191.166L351.624 191.111L351.971 222.609L347.022 222.664L346.674 191.166Z"
        fill="white"
      />
      <path
        d="M355.407 191.09L368.905 190.831L368.991 195.33L360.442 195.494L360.602 203.818L367.396 203.688L367.482 208.187L360.688 208.317L360.873 217.99L369.422 217.826L369.508 222.325L356.01 222.584L355.407 191.09Z"
        fill="white"
      />
      <path
        d="M378.836 222.521C376.437 222.594 374.602 221.975 373.332 220.663C372.06 219.322 371.385 217.376 371.307 214.828L371.252 213.028L375.93 212.885L375.996 215.044C376.058 217.083 376.944 218.077 378.653 218.025C379.493 217.999 380.115 217.74 380.521 217.247C380.955 216.724 381.155 215.907 381.121 214.798C381.081 213.478 380.745 212.333 380.115 211.362C379.484 210.361 378.338 209.18 376.676 207.82C374.581 206.083 373.108 204.508 372.254 203.093C371.399 201.649 370.944 200.012 370.888 198.183C370.812 195.694 371.383 193.755 372.601 192.368C373.818 190.95 375.626 190.204 378.025 190.131C380.394 190.058 382.199 190.693 383.441 192.036C384.712 193.348 385.386 195.278 385.464 197.827L385.504 199.131L380.826 199.274L380.777 197.655C380.744 196.576 380.51 195.802 380.075 195.335C379.64 194.839 379.017 194.602 378.208 194.627C376.559 194.678 375.765 195.707 375.826 197.716C375.861 198.856 376.193 199.911 376.823 200.882C377.483 201.853 378.645 203.018 380.307 204.378C382.431 206.113 383.905 207.704 384.73 209.15C385.554 210.595 385.997 212.307 386.058 214.286C386.136 216.865 385.552 218.864 384.305 220.283C383.088 221.701 381.265 222.447 378.836 222.521Z"
        fill="white"
      />
      <path
        d="M405.31 189.518L412.006 189.168L418.774 220.357L413.831 220.616L412.605 214.416L412.61 214.506L406.993 214.8L406.416 221.004L401.832 221.243L405.31 189.518ZM411.803 210.268L408.787 194.834L408.697 194.839L407.354 210.5L411.803 210.268Z"
        fill="white"
      />
      <path
        d="M418.686 188.826L424.883 188.417L430.928 206.914L431.018 206.908L429.777 188.094L434.178 187.804L436.251 219.236L431.177 219.57L423.736 197.016L423.647 197.022L425.16 219.967L420.76 220.257L418.686 188.826Z"
        fill="white"
      />
      <path
        d="M437.37 187.392L444.905 186.779C447.357 186.58 449.249 187.088 450.582 188.304C451.915 189.52 452.685 191.399 452.892 193.94L454.184 209.818C454.391 212.359 453.935 214.338 452.816 215.753C451.697 217.169 449.911 217.976 447.46 218.175L439.924 218.789L437.37 187.392ZM447.005 213.698C447.812 213.632 448.406 213.343 448.785 212.83C449.195 212.315 449.356 211.52 449.268 210.443L447.94 194.117C447.853 193.041 447.565 192.282 447.078 191.84C446.62 191.395 445.988 191.206 445.18 191.272L442.669 191.476L444.493 213.902L447.005 213.698Z"
        fill="white"
      />
      <path
        d="M481.183 215.753C478.796 216.003 476.92 215.522 475.556 214.308C474.188 213.064 473.371 211.174 473.105 208.638L472.916 206.848L477.571 206.359L477.797 208.507C478.01 210.536 478.967 211.461 480.667 211.282C481.503 211.194 482.104 210.89 482.472 210.368C482.866 209.814 483.005 208.985 482.889 207.881C482.751 206.568 482.332 205.451 481.632 204.529C480.928 203.577 479.697 202.485 477.939 201.252C475.722 199.675 474.135 198.213 473.179 196.866C472.22 195.488 471.645 193.89 471.454 192.07C471.193 189.593 471.619 187.618 472.731 186.144C473.84 184.64 475.588 183.762 477.975 183.511C480.332 183.263 482.179 183.763 483.517 185.01C484.881 186.224 485.696 188.099 485.963 190.635L486.099 191.933L481.445 192.422L481.276 190.811C481.163 189.737 480.872 188.983 480.405 188.55C479.934 188.087 479.295 187.897 478.49 187.982C476.849 188.154 476.133 189.24 476.343 191.239C476.463 192.373 476.872 193.401 477.573 194.323C478.303 195.241 479.547 196.317 481.305 197.55C483.552 199.124 485.14 200.601 486.07 201.981C486.999 203.362 487.567 205.036 487.774 207.006C488.044 209.571 487.61 211.608 486.471 213.115C485.362 214.619 483.599 215.499 481.183 215.753Z"
        fill="white"
      />
      <path
        d="M488.309 183.07L501.715 181.484L502.244 185.953L493.753 186.957L494.731 195.224L501.479 194.426L502.007 198.895L495.259 199.693L496.396 209.301L504.887 208.297L505.415 212.766L492.009 214.352L488.309 183.07Z"
        fill="white"
      />
      <path
        d="M504.507 181.158L511.778 180.189C514.305 179.852 516.228 180.201 517.546 181.236C518.861 182.241 519.681 183.963 520.006 186.401L520.261 188.319C520.694 191.56 519.897 193.755 517.87 194.903L517.882 194.992C519.119 195.19 520.049 195.808 520.672 196.845C521.324 197.878 521.773 199.316 522.019 201.159L522.75 206.646C522.869 207.538 522.996 208.263 523.131 208.82C523.262 209.347 523.482 209.862 523.791 210.366L518.795 211.032C518.549 210.55 518.367 210.09 518.248 209.652C518.129 209.214 517.992 208.415 517.838 207.256L517.076 201.546C516.886 200.119 516.515 199.154 515.964 198.653C515.443 198.147 514.617 197.97 513.487 198.12L511.792 198.346L513.576 211.728L508.67 212.382L504.507 181.158ZM512.982 193.648C513.963 193.517 514.658 193.167 515.066 192.598C515.504 192.025 515.644 191.144 515.486 189.955L515.164 187.546C515.014 186.416 514.697 185.626 514.213 185.176C513.759 184.722 513.101 184.552 512.238 184.667L510.008 184.965L511.198 193.886L512.982 193.648Z"
        fill="white"
      />
      <path
        d="M520.707 178.612L525.647 177.869L532.487 201.55L532.576 201.536L532.143 176.891L536.638 176.215L536.608 208.074L530.112 209.052L520.707 178.612Z"
        fill="white"
      />
      <path
        d="M539.677 175.865L544.563 175.072L549.612 206.165L544.726 206.958L539.677 175.865Z"
        fill="white"
      />
      <path
        d="M560.87 204.884C558.535 205.292 556.631 204.939 555.158 203.826C553.714 202.708 552.78 200.937 552.357 198.514L549.445 181.846C549.022 179.423 549.3 177.441 550.279 175.899C551.288 174.353 552.96 173.375 555.295 172.968C557.629 172.56 559.519 172.915 560.963 174.033C562.436 175.146 563.384 176.914 563.808 179.338L564.381 182.618L559.771 183.423L559.143 179.833C558.808 177.912 557.827 177.093 556.202 177.377C554.577 177.661 553.932 178.764 554.267 180.684L557.295 198.017C557.625 199.908 558.603 200.712 560.228 200.428C561.854 200.144 562.501 199.057 562.171 197.165L561.342 192.422L565.953 191.617L566.719 196.005C567.143 198.429 566.85 200.414 565.841 201.96C564.861 203.502 563.204 204.476 560.87 204.884Z"
        fill="white"
      />
      <path
        d="M564.906 171.39L578.163 168.841L579.012 173.26L570.616 174.874L572.188 183.049L578.861 181.766L579.711 186.185L573.038 187.468L574.865 196.969L583.261 195.355L584.111 199.774L570.853 202.323L564.906 171.39Z"
        fill="white"
      />
      <path
        d="M593.962 198.413C591.612 198.904 589.698 198.615 588.217 197.545C586.731 196.446 585.727 194.648 585.205 192.152L584.837 190.39L589.418 189.433L589.86 191.547C590.277 193.544 591.323 194.367 592.997 194.017C593.819 193.846 594.387 193.482 594.7 192.926C595.036 192.335 595.09 191.496 594.863 190.409C594.593 189.117 594.063 188.048 593.273 187.202C592.477 186.326 591.142 185.364 589.268 184.315C586.903 182.971 585.176 181.676 584.089 180.433C582.995 179.159 582.261 177.627 581.887 175.836C581.378 173.399 581.601 171.39 582.559 169.811C583.51 168.202 585.16 167.153 587.509 166.662C589.829 166.177 591.717 166.487 593.174 167.592C594.654 168.662 595.655 170.445 596.177 172.941L596.444 174.218L591.863 175.176L591.532 173.59C591.311 172.533 590.945 171.812 590.436 171.429C589.921 171.015 589.266 170.891 588.474 171.057C586.859 171.395 586.257 172.547 586.668 174.515C586.901 175.631 587.413 176.612 588.202 177.458C589.022 178.298 590.368 179.243 592.243 180.291C594.637 181.63 596.366 182.939 597.431 184.218C598.495 185.497 599.23 187.106 599.635 189.044C600.163 191.57 599.936 193.64 598.956 195.254C598.005 196.863 596.34 197.916 593.962 198.413Z"
        fill="white"
      />
      <g filter="url(#filter7_i_6_4851)">
        <path
          d="M59.5 188.5C59.5 198.441 36.5 182.5 36.5 182.5C36.5 182.5 20 170.441 20 160.5C20 150.559 38 162.5 38 162.5C38 162.5 59.5 178.559 59.5 188.5Z"
          fill="#F28F29"
        />
      </g>
      <g filter="url(#filter8_d_6_4851)">
        <path
          d="M42.5 170C41 170.667 38.5 172.5 37 175"
          stroke="#FFED81"
          strokeOpacity="0.62"
          strokeLinecap="round"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter9_d_6_4851)">
        <path
          d="M48.5 176C47 176.667 44.5 178.5 43 181"
          stroke="#FFED81"
          strokeOpacity="0.62"
          strokeLinecap="round"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter10_d_6_4851)">
        <path
          d="M36.5 165C35 165.667 32.5 167.5 31 170"
          stroke="#FFED81"
          strokeOpacity="0.62"
          strokeLinecap="round"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter11_f_6_4851)">
        <path
          d="M43.0781 162C42.8116 160.5 43.0781 157.5 46.2759 157.5C49.4737 157.5 49.2073 154.5 48.6743 153"
          stroke="#FFF9F3"
          strokeLinecap="round"
        />
      </g>
      <g filter="url(#filter12_f_6_4851)">
        <path
          d="M50.0781 166C49.8116 164.5 50.0781 161.5 53.2759 161.5C56.4737 161.5 56.2073 158.5 55.6743 157"
          stroke="#FFF9F3"
          strokeLinecap="round"
        />
      </g>
      <g filter="url(#filter13_f_6_4851)">
        <path
          d="M55.0781 172C54.8116 170.5 55.0781 167.5 58.2759 167.5C61.4737 167.5 61.2073 164.5 60.6743 163"
          stroke="#FFF9F3"
          strokeLinecap="round"
        />
      </g>
      <g filter="url(#filter14_i_6_4851)">
        <path
          d="M613.5 185.5C613.5 195.441 636.5 179.5 636.5 179.5C636.5 179.5 653 167.441 653 157.5C653 147.559 635 159.5 635 159.5C635 159.5 613.5 175.559 613.5 185.5Z"
          fill="#F28F29"
        />
      </g>
      <g filter="url(#filter15_d_6_4851)">
        <path
          d="M630.5 167C632 167.667 634.5 169.5 636 172"
          stroke="#FFED81"
          strokeOpacity="0.62"
          strokeLinecap="round"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter16_d_6_4851)">
        <path
          d="M624.5 173C626 173.667 628.5 175.5 630 178"
          stroke="#FFED81"
          strokeOpacity="0.62"
          strokeLinecap="round"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter17_d_6_4851)">
        <path
          d="M636.5 162C638 162.667 640.5 164.5 642 167"
          stroke="#FFED81"
          strokeOpacity="0.62"
          strokeLinecap="round"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter18_f_6_4851)">
        <path
          d="M629.922 159C630.188 157.5 629.922 154.5 626.724 154.5C623.526 154.5 623.793 151.5 624.326 150"
          stroke="#FFF9F3"
          strokeLinecap="round"
        />
      </g>
      <g filter="url(#filter19_f_6_4851)">
        <path
          d="M622.922 163C623.188 161.5 622.922 158.5 619.724 158.5C616.526 158.5 616.793 155.5 617.326 154"
          stroke="#FFF9F3"
          strokeLinecap="round"
        />
      </g>
      <g filter="url(#filter20_f_6_4851)">
        <path
          d="M617.922 169C618.188 167.5 617.922 164.5 614.724 164.5C611.526 164.5 611.793 161.5 612.326 160"
          stroke="#FFF9F3"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <filter
          id="filter7_i_6_4851"
          x="20"
          y="156.547"
          width="39.5"
          height="35.2169"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.795833 0 0 0 0 0.412022 0 0 0 0 0.0165799 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_6_4851"
          />
        </filter>
        <filter
          id="filter8_d_6_4851"
          x="34.4999"
          y="167.5"
          width="10.5002"
          height="10.0002"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.541667 0 0 0 0 0.274876 0 0 0 0 0 0 0 0 0.54 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6_4851"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6_4851"
            result="shape"
          />
        </filter>
        <filter
          id="filter9_d_6_4851"
          x="40.4999"
          y="173.5"
          width="10.5002"
          height="10.0002"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.541667 0 0 0 0 0.274876 0 0 0 0 0 0 0 0 0.54 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6_4851"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6_4851"
            result="shape"
          />
        </filter>
        <filter
          id="filter10_d_6_4851"
          x="28.4999"
          y="162.5"
          width="10.5002"
          height="10.0002"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.541667 0 0 0 0 0.274876 0 0 0 0 0 0 0 0 0.54 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6_4851"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6_4851"
            result="shape"
          />
        </filter>
        <filter
          id="filter11_f_6_4851"
          x="39.5001"
          y="149.5"
          width="12.9999"
          height="16.0002"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1.5"
            result="effect1_foregroundBlur_6_4851"
          />
        </filter>
        <filter
          id="filter12_f_6_4851"
          x="46.5001"
          y="153.5"
          width="12.9999"
          height="16.0002"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1.5"
            result="effect1_foregroundBlur_6_4851"
          />
        </filter>
        <filter
          id="filter13_f_6_4851"
          x="51.5001"
          y="159.5"
          width="12.9999"
          height="16.0002"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1.5"
            result="effect1_foregroundBlur_6_4851"
          />
        </filter>
        <filter
          id="filter14_i_6_4851"
          x="613.5"
          y="153.547"
          width="39.5"
          height="35.2169"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.795833 0 0 0 0 0.412022 0 0 0 0 0.0165799 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_6_4851"
          />
        </filter>
        <filter
          id="filter15_d_6_4851"
          x="628"
          y="164.5"
          width="10.5002"
          height="10.0002"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.541667 0 0 0 0 0.274876 0 0 0 0 0 0 0 0 0.54 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6_4851"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6_4851"
            result="shape"
          />
        </filter>
        <filter
          id="filter16_d_6_4851"
          x="622"
          y="170.5"
          width="10.5002"
          height="10.0002"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.541667 0 0 0 0 0.274876 0 0 0 0 0 0 0 0 0.54 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6_4851"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6_4851"
            result="shape"
          />
        </filter>
        <filter
          id="filter17_d_6_4851"
          x="634"
          y="159.5"
          width="10.5002"
          height="10.0002"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.541667 0 0 0 0 0.274876 0 0 0 0 0 0 0 0 0.54 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6_4851"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6_4851"
            result="shape"
          />
        </filter>
        <filter
          id="filter18_f_6_4851"
          x="620.5"
          y="146.5"
          width="13"
          height="16.0002"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1.5"
            result="effect1_foregroundBlur_6_4851"
          />
        </filter>
        <filter
          id="filter19_f_6_4851"
          x="613.5"
          y="150.5"
          width="13"
          height="16.0002"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1.5"
            result="effect1_foregroundBlur_6_4851"
          />
        </filter>
        <filter
          id="filter20_f_6_4851"
          x="608.5"
          y="156.5"
          width="13"
          height="16.0002"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1.5"
            result="effect1_foregroundBlur_6_4851"
          />
        </filter>
      </defs>
    </svg>
  </LogoWrapper>
)
